import { makeAutoObservable } from "mobx"
import Loader from "reusable/mobx-helpers/Loader"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"

export default class PdfStore {
   downloadLoader = new Loader(false)
   private _isGeneratingPdf = false
   private loomElements: NodeListOf<Element> | null

   constructor() {
      makeAutoObservable(this)
   }

   get isGeneratingPdf() {
      return this._isGeneratingPdf
   }

   set isGeneratingPdf(isGeneratingPdf: boolean) {
      this._isGeneratingPdf = isGeneratingPdf
      if (isGeneratingPdf) {
         this.loomElements = document.querySelectorAll('[id^="loom-"]')
         for (const loomElement of this.loomElements) {
            loomElement.remove()
         }
      } else if (this.loomElements) {
         for (const loomElement of this.loomElements) {
            document.body.appendChild(loomElement)
         }
         this.loomElements = null
      }
   }
}

export const { Provider: PdfStoreProvider, useProvidedStore: usePdfStore } = createStoreContext(PdfStore)
